import React, { ReactNode } from "react";

import TransparentHeader from "components/Header/TransparentHeader";
import TransparentFooter from "components/Footer/TransparentFooter";

import "./index.scss";

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="auth-layout">
      <TransparentHeader />
      <div className="auth-children">{children}</div>
      <TransparentFooter />
    </div>
  );
};

export default AuthLayout;
